; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.etf = inovestor.ms.etf || {};
})(inovestor);


; (function (etf, undefined) {
    // Create plugin namespace with any desired config variable
    etf.largestMostActive = {
        config: {
            apiRelativeUrl: 'etfs/largestMostActive',
            filterOptionsApiRelativeUrl: 'etfs/largestMostActive/filterOptions'
        }
    };

})(inovestor.ms.etf);
; (function (etf, undefined) {
    etf.largestMostActive.cache = {
        get: function (stateStore) {
            try {
                if (stateStore == null || stateStore.get == null) return null

                var data = stateStore.get()
                if (data == null) return null

                if (data.apiDataExpiration == null || data.apiDataExpiration < new Date().getTime()) {
                    data.apiData = null
                    data.apiFilterOptions = null
                }

                return data
            } catch (e) {
                console.error(e)
            }
            return null
        },

        set: function (viewModel, stateStore) {
            try {
                if (stateStore == null || stateStore.set == null) return

                stateStore.set({
                    // api
                    apiData: viewModel.apiData(),
                    apiFilterOptions: viewModel.apiFilterOptions(),
                    apiDataExpiration: new Date().getTime() + (1000 * 60 * 60 * 4), // 4 hours

                    // sponsor feature
                    showResultsFromAllProviders: viewModel.showResultsFromAllProviders(),

                    // compare feature
                    selectedRows: viewModel.selectedRows().map(function (x) { return x.symbol }),

                    // columns visibility
                    hiddenColumns: viewModel.hiddenColumns(),

                    // sorting
                    sortOn: viewModel.sortOn(),
                    sortAscending: viewModel.sortAscending(),

                    // pagination
                    resultsPerPage: viewModel.resultsPerPage(),
                    currentPageIndex: viewModel.currentPageIndex(),

                    // filters
                    selectedAssetClasses: viewModel.selectedAssetClasses(),
                    selectedSubAssetClasses: viewModel.selectedSubAssetClasses(),
                    selectedStrategies: viewModel.selectedStrategies(),
                    selectedRegions: viewModel.selectedRegions(),
                    selectedStructures: viewModel.selectedStructures()
                })
            } catch (e) {
                console.error(e)
            }
        }
    }
})(inovestor.ms.etf);
ko.components.register('etf-largest-most-active-filter', {
    viewModel: function (params) {
        this.params = params

        this.inputText = ko.pureComputed(function () {
            var language = params.language == null ? 'en' : ko.unwrap(params.language)
            var selection = params.selection()
            var items = params.items()

            if (selection == null || selection.length === 0) return language === 'fr' ? 'Sélectionner des filters' : 'Select filters'

            return selection.map(function (x) {
                var item = items.find(function (y) { return y.code === x })
                return item == null ? x : language === 'fr' ? item.nameFr : item.nameEn
            }).join(', ')
        })
    },

    template: `
<div class="etf-largest-most-active__filter" data-bind="css: { 'etf-largest-most-active__filter--empty': params.selection().length === 0 }">
    <div class="etf-largest-most-active__filter-header">
        <div class="etf-largest-most-active__filter-title" data-bind="text: params.title"></div>
        <div class="badge" data-bind="visible: params.selection().length > 0, text: params.selection().length + '/' + params.items().length"></div>
    </div>

    <ino-ms-checkbox-list-dropdown params="
        triggerTag: 'a',
        triggerAttributes: { 'aria-label': params.title },
        options: params.items,
        selection: params.selection,
        getText: function (item) { return ko.pureComputed(function () { return inovestor.ms.ko.currentLanguage() === 'fr' ? item.nameFr : item.nameEn }) },
        getValue: function (item) { return item.code },
        displaySelectAll: true
    ">
        <div class="etf-largest-most-active__filter-input-text" data-bind="text: inputText"></div>
        <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
    </ino-ms-checkbox-list-dropdown>
</div>
    `
})
; (function ($, ko, inovestor, undefined) {
    function getInitialState (stateStore) {
        return $.extend(true, {
            apiData: null,
            apiFilterOptions: null,

            showResultsFromAllProviders: false,

            selectedRows: [],

            hiddenColumns: [],

            sortOn: 'aggregatedAssetUnderManagement',
            sortAscending: false,

            resultsPerPage: 25,
            currentPageIndex: 0,

            selectedAssetClasses: [],
            selectedSubAssetClasses: [],
            selectedStrategies: [],
            selectedRegions: [],
            selectedStructures: []
        }, inovestor.ms.etf.largestMostActive.cache.get(stateStore))
    }

    inovestor.ms.etf.largestMostActive.viewModels = {};
    inovestor.ms.etf.largestMostActive.viewModels.largestMostActiveViewModel = function (plugin) {
        var self = this

        var initialState = getInitialState(plugin.options.stateStore)

        // Api stuff

        self.isLoading = ko.observable(true);
        self.hasError = ko.observable(false);
        self.apiData = ko.observable(initialState.apiData);
        self.apiFilterOptions = ko.observable(initialState.apiFilterOptions);
        self.showGenericErrorModal = ko.observable(false);

        self.init = function () {
            if (self.apiData() != null && self.apiFilterOptions() != null) {
                self.isLoading(false)
                setupPagination(self.uiData().length)
                return $.Deferred().resolve()
            }

            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } }

            var fetchDataPromise = inovestor.ms.core.ajaxApi(inovestor.ms.etf.largestMostActive.config.apiRelativeUrl, options).then(function (data) {
                self.apiData(data);
            })
            var fetchFilterOptionsPromise = inovestor.ms.core.ajaxApi(inovestor.ms.etf.largestMostActive.config.filterOptionsApiRelativeUrl, options).then(function (data) {
                self.apiFilterOptions(data);
            })

            return $.when(fetchDataPromise, fetchFilterOptionsPromise).then(function () {
                inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore);

                // ensure that the selected filters still exists
                var apiFilterOptions = self.apiFilterOptions()
                self.selectedAssetClasses(self.selectedAssetClasses().filter(function (x) { return apiFilterOptions.assetClasses.some(function (y) { return y.code === x }) }))
                self.selectedSubAssetClasses(self.selectedSubAssetClasses().filter(function (x) { return apiFilterOptions.subAssetClasses.some(function (y) { return y.code === x }) }))
                self.selectedStrategies(self.selectedStrategies().filter(function (x) { return apiFilterOptions.strategies.some(function (y) { return y.code === x }) }))
                self.selectedRegions(self.selectedRegions().filter(function (x) { return apiFilterOptions.regions.some(function (y) { return y.code === x }) }))
                var structures = self.selectedStructures()
                self.selectedStructures(self.selectedStructures().filter(function (x) { return structures.some(function (y) { return x.includes(y.code) }) }))

            }).always(function () {
                self.isLoading(false);
            })
        }

        // Base stuff

        self.language = ko.observable(inovestor.ms.core.currentLanguage)
        self.resources = ko.observable()
        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.etf.largestMostActive.resources[inovestor.ms.core.currentLanguage]
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null
            self.resources(currentResource)
            self.language(inovestor.ms.core.currentLanguage)
        }

        // Sponsor feature

        self.sponsorFeatureIsActive = plugin.options.sponsorIssuerCompanyCodes != null && plugin.options.sponsorIssuerCompanyCodes.length > 0
        self.sponsorCheckboxText = plugin.options.sponsorCheckboxText
        self.showResultsFromAllProviders = ko.observable(initialState.showResultsFromAllProviders)
        self.showResultsFromAllProviders.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })
       
        // Columns visibility

        self.columns = [
            'name',
            'netAssets',
            'maxManagementFee',
            'price',
            'averageVolume30Days',
            'aggregatedAssetUnderManagement'
        ]

        self.visibleColumns = ko.observableArray(self.columns.filter(function (x) { return !initialState.hiddenColumns.includes(x) }))
        self.visibleColumns.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })

        self.hiddenColumns = ko.pureComputed(function () {
            var visibleColumns = self.visibleColumns()
            return self.columns.filter(function (x) { return !visibleColumns.includes(x) })
        })

        // Sorting

        self.sortOn = ko.observable(initialState.sortOn)
        self.sortAscending = ko.observable(initialState.sortAscending)
        self.toggleSorting = function (key) {
            if (self.sortOn() === key) {
                self.sortAscending(!self.sortAscending())
            } else {
                self.sortOn(key)
                self.sortAscending(true)
            }
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        }

        // Filters

        self.noFilterApplied = ko.pureComputed(function () {
            return self.selectedAssetClasses().length === 0 &&
                self.selectedSubAssetClasses().length === 0 &&
                self.selectedStrategies().length === 0 &&
                self.selectedStructures().length === 0 &&
                self.selectedRegions().length === 0
        })

        self.structures = ko.pureComputed(function () {
            var filterOptions = self.apiFilterOptions()
            if (filterOptions == null) return []

            return filterOptions.currencies.reduce(function (agg, x) {
                filterOptions.currencyHedgedValues.forEach(function (y) {
                    agg.push({ code: x.code + ';' + y.code, nameEn: x.nameEn + ' ' + y.nameEn, nameFr: x.nameFr + ' ' + y.nameFr })
                })
                return agg
            }, [])
        })

        self.selectedAssetClasses = ko.observableArray(initialState.selectedAssetClasses)
        self.selectedAssetClasses.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })
        self.selectedSubAssetClasses = ko.observableArray(initialState.selectedSubAssetClasses)
        self.selectedSubAssetClasses.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })
        self.selectedStrategies = ko.observableArray(initialState.selectedStrategies)
        self.selectedStrategies.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })
        self.selectedRegions = ko.observableArray(initialState.selectedRegions)
        self.selectedRegions.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })
        self.selectedStructures = ko.observableArray(initialState.selectedStructures)
        self.selectedStructures.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })

        self.clearFilters = function () {
            self.selectedAssetClasses([])
            self.selectedSubAssetClasses([])
            self.selectedStrategies([])
            self.selectedRegions([])
            self.selectedStructures([])
        }

        self.uiData = ko.pureComputed(function () {
            var data = self.apiData()
            if (data == null) return []

            var sortOn = self.sortOn()
            var sortAscending = self.sortAscending()

            var issuerCompanyCodes = self.sponsorFeatureIsActive && self.showResultsFromAllProviders() ? [] : plugin.options.sponsorIssuerCompanyCodes
            var selectedAssetClasses = self.selectedAssetClasses()
            var selectedSubAssetClasses = self.selectedSubAssetClasses()
            var selectedStrategies = self.selectedStrategies()
            var selectedRegions = self.selectedRegions()
            var selectedStructures = self.selectedStructures()

            return data.filter(function (x) {
                if (issuerCompanyCodes.length > 0 && !issuerCompanyCodes.includes(x.issuerCompanyCode)) {
                    return false
                }

                if (selectedAssetClasses.length > 0 && !selectedAssetClasses.includes(x.assetClassCode)) {
                    return false
                }

                if (selectedSubAssetClasses.length > 0 && !selectedSubAssetClasses.includes(x.subAssetClassCode)) {
                    return false
                }

                if (selectedStrategies.length > 0 && !selectedStrategies.includes(x.strategyCode)) {
                    return false
                }

                if (selectedRegions.length > 0 && !selectedRegions.includes(x.regionCode)) {
                    return false
                }

                if (
                    selectedStructures.length > 0 && 
                    !selectedStructures.some(function (y) { 
                        var codes = y.split(';')
                        return x.currencyCode === codes[0] && x.currencyHedged === codes[1]
                    })
                ) {
                    return false
                }

                return true
            }).map(function (x) {
                return $.extend(true, {}, x, {
                    name: inovestor.ms.core.currentLanguage === 'fr' ? x.nameFr : x.nameEn,
                    url: inovestor.ms.core.isEmptyString(plugin.options.redirectUrl) ? null : inovestor.ms.core.stringFormat(plugin.options.redirectUrl, { symbol: x.symbol, category: 'etf' }),
                    ticker: mapSymbolToTicker(x.symbol)
                })
            }).sort(function (a, b) {
                var valueA = a[sortOn]
                var valueB = b[sortOn]

                if (valueA == null && valueB == null) return 0
                if (valueA == null) return sortAscending ? 1 : -1
                if (valueB == null) return sortAscending ? -1 : 1
                if (valueA < valueB) return sortAscending ? -1 : 1
                if (valueA > valueB) return sortAscending ? 1 : -1

                return 0
            }).map(function (x) {
                if (self.sponsorFeatureIsActive && self.showResultsFromAllProviders() && plugin.options.sponsorIssuerCompanyCodes.includes(x.issuerCompanyCode)) {
                    return $.extend(true, {}, x, {
                        name: '<b>' + x.name + '</b>'
                    })
                }
                return x
            })
        }).extend({ rateLimit: 1 }) // clear filters would recalculates this computed many times if we don't rateLimit it

        self.uiData.subscribe(function (data) {
            self.selectedRows([])
            setupPagination(data.length)
        })

        // Compare feature

        self.compareFeatureIsActive = !inovestor.ms.core.isEmptyString(plugin.options.comparatorUrl)
        self.compareMaxNumberOfSymbols = plugin.options.compareMaxNumberOfSymbols

        self.canCompare = ko.pureComputed(function () {
            return self.compareFeatureIsActive && self.selectedRows().length > 1 && self.selectedRows().length <= self.compareMaxNumberOfSymbols
        })

        self.compare = function () {
            if (!self.compareFeatureIsActive) return

            var distinctSelectedSymbols = self.selectedRows().reduce(function (agg, x) {
                if (!inovestor.ms.core.isEmptyString(x.symbol) && !agg.includes(x.symbol.toUpperCase())) {
                    agg.push(x.symbol.toUpperCase())
                }
                return agg
            }, [])

            if (distinctSelectedSymbols.length < 2) return

            location.href = inovestor.ms.core.stringFormat(plugin.options.comparatorUrl, { symbols: distinctSelectedSymbols.join(',') })
        }

        self.selectedRows = ko.observableArray(self.uiData() == null ? [] : self.uiData().filter(function (x) { return initialState.selectedRows.includes(x.symbol) }))
        self.selectedRows.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })

        // Pagination

        self.resultsPerPage = ko.observable(initialState.resultsPerPage)
        self.resultsPerPage.subscribe(function () {
            setupPagination(self.uiData().length)  
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })
        self.currentPageIndex = ko.observable(initialState.currentPageIndex)
        self.currentPageIndex.subscribe(function () {
            inovestor.ms.etf.largestMostActive.cache.set(self, plugin.options.stateStore)
        })
        self.currentPageItems = ko.pureComputed(function () {
            var startIndex = self.currentPageIndex() * self.resultsPerPage()
            return (self.uiData() || []).slice(startIndex, startIndex + self.resultsPerPage())
        })
        self.currentPageInfo = ko.pureComputed(function () {
            var start = self.currentPageIndex() * self.resultsPerPage() + 1;
            var end = self.currentPageIndex() * self.resultsPerPage() + self.currentPageItems().length;
            var total = (self.uiData() || []).length;
            return inovestor.ms.core.stringFormat(self.resources().pagination.paginationInfo, { start: start, end: end, total: total });
        })

        function setupPagination (dataLength) {
            var $pagination = $('#largest-most-active-pagination')
            $pagination.twbsPagination('destroy')

            if (!dataLength || dataLength === 0)
                return

            var numPages = Math.ceil(dataLength / self.resultsPerPage())

            if (self.currentPageIndex() > (numPages - 1))
                self.currentPageIndex(numPages - 1)

            $pagination.twbsPagination({
                totalPages: numPages,
                visiblePages: 5,
                initiateStartPageClick: false,
                startPage: self.currentPageIndex() + 1,
                first: self.resources().pagination.firstPage,
                prev: self.resources().pagination.previousPage,
                next: self.resources().pagination.nextPage,
                last: self.resources().pagination.lastPage,
                onPageClick: function (event, page) {
                    self.currentPageIndex(page - 1);
                }
            })
        }

        // Export to CSV

        self.exportToCsv = function () {
            try {
                var rows = [
                    [
                        encodeCsvStringValue(self.resources().ticker),
                        encodeCsvStringValue(self.resources().name),
                        encodeCsvStringValue(self.resources().netAssets),
                        encodeCsvStringValue(self.resources().maxManagementFee),
                        encodeCsvStringValue(self.resources().price),
                        encodeCsvStringValue(self.resources().averageVolume30Days),
                        encodeCsvStringValue(self.resources().aggregatedAssetUnderManagement)

                    ]
                ]
    
                self.uiData().forEach(function (x) {
                    rows.push([
                        encodeCsvStringValue(x.symbol),
                        encodeCsvStringValue(inovestor.ms.core.currentLanguage === 'fr' ? x.nameFr : x.nameEn),
                        x.assetUnderManagement,
                        x.managementFee,
                        x.nav,
                        x.averageVolume30Days,
                        x.aggregatedAssetUnderManagement
                    ])
                })
    
                var csvString = rows.map(function (row) { return row.join(',') }).join('\r\n')
    
                var blob = new Blob([csvString], { type: "text/csv;charset=utf-8" })
                saveAs(blob, inovestor.ms.core.currentLanguage === 'fr' ? 'FnbLesPlusImportantsEtLesPlusLiquides.csv' : 'LargestAndMostLiquidEtfs.csv')
            } catch (e) {
                $('.etf-largest-most-active__generic-error-modal').modal()
                console.error(e)
            }
        }

        function encodeCsvStringValue (value) {
            if (value == null) return ''
            return '"' + value.replace(/"/g, '""') + '"'
        }

        function mapSymbolToTicker (symbol) {
            if (symbol == null) return null
            var parts = symbol.split(':')
            return parts.length > 1 ? parts[1] : parts[0]
        }
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsEtfLargestMostActive';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsEtfLargestMostActive.defaults;

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        this._viewModel = new inovestor.ms.etf.largestMostActive.viewModels.largestMostActiveViewModel(this);

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin._viewModel.updateResources();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.largestMostActive;
            var filePath = plugin.options.templatePaths.largestMostActive;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'largestMostActive.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.bindModel();
                plugin.render();
            }).then(function () {
                plugin._viewModel.init().always(function () {
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        }
    });

    // JQuery Plugin wrapper
    $.fn.inoMsEtfLargestMostActive = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsEtfLargestMostActive.defaults = {
        onError: null,
        onReady: null,
        redirectUrl: null,
        comparatorUrl: null,
        compareMaxNumberOfSymbols: 5,
        sponsorIssuerCompanyCodes: null,
        sponsorCheckboxText: {
            en: 'Show sponsored ETFs only',
            fr: 'Afficher seulement les FNB commandités'
        },
        stateStore: null, // { get: () => State | null | undefined, set: (state: State) => void }
        templatePaths: {
            largestMostActive: null
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (etf, undefined) {
    etf.largestMostActive.resources = etf.largestMostActive.resources || {};
    etf.largestMostActive.resources["en"] = {
        largestMostActiveTitle: 'Largest and Most Liquid ETFs',
        applyFilters: 'FILTERS',
        clearFilters: 'CLEAR FILTERS',
        results: 'Results',
        hideShowColumns: 'Hide/Show Columns',
        noResultsFound: 'No results found',
        showResultsFromAllProviders: 'Show results from all providers',
        downloadCsv: 'DOWNLOAD CSV',
        close: 'Close',

        assetClass: 'Asset Class',
        subAssetClass: 'Sub-Asset Class',
        strategy: 'Strategy',
        structure: 'Structure',
        region: 'Region',

        ticker: 'Ticker',
        name: 'Name',
        netAssets: 'Series AUM',
        maxManagementFee: 'Mng. Fee',
        price: 'Price (NAV)',
        averageVolume30Days: 'Avg. Volume',
        aggregatedAssetUnderManagement: 'Aggregated AUM',

        footnote: "* Screening is based on Canadian-listed ETFs with a minimum of $100 million in Assets Under Management (AUM) and an average trading volume of at least $1 million on the last 30 days.",

        pagination: {
            paginationInfo: '{start} - {end} of {total}',
            nextPage: 'Next',
            previousPage: 'Previous',
            firstPage: 'First',
            lastPage: 'Last',
            itemsPerPage: 'Items per page'
        },
        
        compare: {
            selectedItems: 'Selected Items',
            emptySelection: 'Your selection is empty',
            addToComparison: 'Add to comparison',
            itemSelected: '{qty} item selected',
            itemsSelected: '{qty} items selected',
            maxSelectionWarning: 'Select up to {max} items',
            view: 'View',
            close: 'Close',
            compare: 'Compare',
            compareSelectedItems: 'Compare selected etfs',
            checkboxAriaLabel: 'Add "{symbol}" to comparison'
        }
    };
})(inovestor.ms.etf);

; (function (etf, undefined) {
    etf.largestMostActive.resources = etf.largestMostActive.resources || {};
    etf.largestMostActive.resources["fr"] = {
        largestMostActiveTitle: 'Les FNB les plus importants et les plus liquides',
        applyFilters: 'FILTRES',
        clearFilters: 'SUPPRIMER LES FILTRES',
        results: 'Résultats',
        hideShowColumns: 'Masquer/Afficher les colonnes',
        noResultsFound: 'Aucun résultat trouvé',
        showResultsFromAllProviders: 'Montrer les résultats de tous les fournisseurs',
        downloadCsv: 'TÉLÉCHARGER EN CSV',
        close: 'Fermer',

        assetClass: "Classe d'actifs",
        subAssetClass: "Sous-classe d'actifs",
        strategy: 'Stratégie',
        structure: 'Structure',
        region: 'Région',

        ticker: 'Ticker',
        name: 'Nom',
        netAssets: 'Actifs sous gestion de la série',
        maxManagementFee: 'Frais de gestion',
        price: 'Prix (NAV)',
        averageVolume30Days: 'Volume moy.',
        aggregatedAssetUnderManagement: 'Actifs sous gestion agrégés',

        footnote: "* La sélection est basée sur les FNB cotés au Canada avec un actif sous gestion (ASG) d'au moins 100 millions de dollars et un volume de transactions moyen sur 30 jours d'au moins 1 million de dollars.",

        pagination: {
            paginationInfo: '{start} à {end} de {total}',
            nextPage: 'Prochain',
            previousPage: 'Précédent',
            firstPage: 'Premier',
            lastPage: 'Dernier',
            itemsPerPage: 'Items par page'
        },
        
        compare: {
            selectedItems: 'Items sélectionnés',
            emptySelection: 'Votre sélection est vide',
            addToComparison: 'Ajouter à la comparaison',
            itemSelected: '{qty} item sélectionné',
            itemsSelected: '{qty} items sélectionnés',
            maxSelectionWarning: "Sélectionnez jusqu'à {max} articles",
            view: 'Voir',
            close: 'Fermer',
            compare: 'Comparer',
            compareSelectedItems: 'Comparer les fnb sélectionnés',
            checkboxAriaLabel: 'Ajouter "{symbol}" à la comparaison'
        }
    };
})(inovestor.ms.etf);
